import React, { useContext, useEffect } from 'react'
import PageLoader from '../page/pageloader'

import { DataContext } from '../../app'

const NoPageAvaliable = () => <span>Página no disponible.</span>

const PageComponent = ({ node, children, localData, meta, pageData, close, ...props }) => {
	const context = useContext(DataContext)
	const pageName = node.children[0]?.value || 'unknown';
	const page = context.page?.find(page => page.name === pageName)

	useEffect(() => {
		console.log('page-md', 'in', pageName)
		return () => { console.log('page-md', 'out', pageName) }
	}, [pageName])

	return <div className='inner-page w-100'>
		{page ? <PageLoader {...page} isInnerPage /> : <NoPageAvaliable />}
	</div>
}

export default PageComponent